import { combineReducers } from 'redux';

import { campaignsReducer } from './campaigns/campaignsReducer';
import { companiesReducer } from './companies/companiesReducer';
import { contactsReducer } from './contacts/contactsReducer';
import { disposalsReducer } from './disposals/disposalsReducer';
import { savedViewViewingsInsightsReducer } from './insights/savedViewViewingsInsightsReducer';
import { savedViewSocietyDisposalInsightsReducer } from './society-insights/savedViewSocietyDisposalInsightsReducer';

const savedViewsReducer = combineReducers({
  societyDisposalInsights: savedViewSocietyDisposalInsightsReducer,
  viewingsInsights: savedViewViewingsInsightsReducer,
  disposals: disposalsReducer,
  contacts: contactsReducer,
  companies: companiesReducer,
  campaigns: campaignsReducer,
});

export default savedViewsReducer;
